{
  "el": {
    "message": {
      "actions": {
        "delete_message": "Διαγραφή μηνύματος",
        "move_selected": "Μετακίνηση επιλεγμένων μηνυμάτων",
        "send": "Αποστολή"
      },
      "labels": {
        "already_replied": "έχει ήδη απάντηση",
        "cannot_delete_message": "Αυτό το μήνυμα το έχει ήδη διαβάσει ο πελάτης και γι' αυτό δεν μπορεί να διαγραφεί.",
        "changes_not_saved": "Έχεις μη αποθηκευμένες αλλαγές. Θέλεις σίγουρα να συνεχίσεις;\nΥ.Γ.: Μπορείς να ανοίξεις νέα καρτέλα για να πλοηγείσαι ταυτόχρονα σε άλλες σελίδες.",
        "delete_message": "Αυτό διαγράφει το μήνυμα για όλους. Έχε υπόψη σου ότι μπορεί να έχει ήδη σταλεί ειδοποίηση με email, ανάλογα με τις ρυθμίσεις του παραλήπτη.",
        "delete_message_abort": "Το μήνυμα δεν μπορεί να διαγραφεί",
        "move_customer_notification": "Ο πελάτης θα ειδοποιηθεί όταν το μήνυμα μεταφερθεί σε άλλη συνομιλία",
        "move_to": "Μετακίνηση μηνύματος σε...",
        "moved_here": "εδώ από τη συνομιλία",
        "moved_message": "μετέφερε αυτό το μήνυμα",
        "moving_message": "Μετακίνηση μηνύματος",
        "notSeenYet": "Δεν το έχει δει ακόμη",
        "seen_by": "Το είδαν {participants}",
        "to": "σε",
        "you": "εσύ"
      },
      "validation": {
        "message_required": "Το μήνυμα είναι υποχρεωτικό"
      }
    }
  }
}
